import React from "react";
import PropTypes from "prop-types";
import { useBaseMediaUrls } from "../../hooks/useBaseMediaUrls";
import { getImageUrl, transformations } from "../../util/get-url-utils";

import { MediaImage } from "./styled";

const InlineContextImage = ({ title, publicId }) => {
  const cloudinaryUrl = useBaseMediaUrls("images");

  return (
    <MediaImage
      alt={title}
      src={getImageUrl(publicId, cloudinaryUrl, transformations.none)}
    />
  );
};

InlineContextImage.displayName = "InlineContextImage";
InlineContextImage.propTypes = {
  publicId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default InlineContextImage;
